"use client";
import React from "react";
import { SingletonEnvironmentContext } from "./_private/useSingletonEnvironment.js";
const useRTL = () => {
    return React.useContext(SingletonEnvironmentContext).rtl;
};
export default useRTL;
